import React from 'react';
import { useIntl } from 'react-intl';
import { Body } from '../Typography/Body.esm.js';
import '@panwds/tailwindcss';
import '@popperjs/core';
import '../../utils/constants.esm.js';
import 'react-dom';
import { Title } from '../Typography/Title.esm.js';
import { NoResultsAvailableSVG } from './NoResultsAvailableSVG.esm.js';

/**
 * Layout for an empty state graphic, heading, description, and follow up actions.
 */
function EmptyStateLayout({ actions, description, graphic, heading, style }) {
    const intl = useIntl();
    const children = graphic || React.createElement(NoResultsAvailableSVG, { style: { maxWidth: '15rem' } });
    return (React.createElement("div", { className: "tw-flex tw-justify-center" },
        React.createElement("div", { className: "tw-flex tw-flex-col tw-items-center tw-space-y-4 tw-p-4 tw-w-3/4", style: style },
            children,
            React.createElement("div", { className: "tw-text-center" },
                React.createElement(Title, { level: 4, size: "xxs" }, heading !== null && heading !== void 0 ? heading : intl.formatMessage({
                    defaultMessage: 'No Results Available',
                    id: 'Q58RPw',
                    description: 'No results available for section'
                })),
                description && (React.createElement(Body, { appearance: "secondary", size: "sm" }, description))),
            React.createElement("div", null, actions))));
}

export { EmptyStateLayout };
//# sourceMappingURL=EmptyStateLayout.esm.js.map
